const cateringResponsive = () => {
    const cakes = document.querySelector('div[data-menu="cakes"]') as HTMLDivElement
    const savory = document.querySelector('div[data-menu="savory"]') as HTMLDivElement
    const cakesClone = cakes.cloneNode(true) as HTMLDivElement

    const handleResize = () => {
        if (window.innerWidth <= 768) {
            cakes.style.display = "none"
            savory.parentElement.appendChild(cakesClone)
            cakesClone.style.opacity = "1"
            cakesClone.style.translate = "0"
        }
        if (window.innerWidth > 768) {
            cakes.style.display = "flex"
            savory.parentElement.removeChild(cakesClone)
        }
    }

    window.addEventListener('resize', handleResize)
    handleResize()
}

export default cateringResponsive